import { ItemDetailsForm } from "./ItemDetailsForm";
import { CheckoutDetailsForm } from "./CheckoutDetailsForm";
import { useShipContext } from "../../../../context/shipContext";
import { Stepper } from "../../../Steppers/Stepper";
import { ShipFromForm } from "./ShipDetails/ShipFromForm";
import { ShipToForm } from "./ShipDetails/ShipToForm";
import { SelectCourierForm } from "./SelectCourierForm";
import { OrderConfirmationForm } from "./OrderConfirmationForm";
// import { DraftRestoreBanner } from "../../../Alerts/DraftRestoreBanner";
// import { RESET_STATE } from "../../../../reducers/types";

export function ShipForm() {
  const shipSteps = [
    <ShipFromForm />,
    <ShipToForm />,
    <ItemDetailsForm />,
    <SelectCourierForm />,
    <CheckoutDetailsForm />,
    <OrderConfirmationForm />,
  ];

  const steps = [
    {
      id: "01",
      name: "Sender Details",
    },
    {
      id: "02",
      name: "Receiver Details",
    },
    {
      id: "03",
      name: "Item Details",
    },
    {
      id: "04",
      name: "Select Courier",
    },
    {
      id: "05",
      name: "Checkout Details",
    },
  ];

  const { state: shipState, 
    // dispatch, wasRestored 
  } = useShipContext();

  // const handleClearDraft = () => {
  //   localStorage.removeItem("shipFormDraft");
  //   dispatch({ type: RESET_STATE });
  // };
  return (
    <>
      {/* {wasRestored && <DraftRestoreBanner onClear={handleClearDraft} />} */}
      <div className="mb-10">
        <Stepper currentStep={shipState.step} steps={steps} />
      </div>
      <div>{shipSteps[shipState.step]}</div>
    </>
  );
}
